import React from "react";
import { AlertTriangle } from "lucide-react";

const ConfirmModal = ({
  title = "Are you sure?",
  message,
  confirmText = "Yes, Proceed",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => (
  <div className="fixed inset-0 z-[9998] bg-black bg-opacity-50 flex items-center justify-center px-4">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6">
      <div className="flex flex-col items-center text-center">
        <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mb-3">
          <AlertTriangle className="w-6 h-6 text-red-600" />
        </div>
        <h3 className="text-lg font-bold text-gray-900 font-montserrat">
          {title}
        </h3>
        <p className="text-sm text-gray-600 mt-2 font-montserrat">{message}</p>
      </div>

      <div className="flex gap-3 mt-6">
        <button
          onClick={onCancel}
          className="flex-1 py-2.5 rounded-full border border-gray-300 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition"
        >
          {cancelText}
        </button>
        <button
          onClick={onConfirm}
          className="flex-1 py-2.5 rounded-full bg-red-600 text-white font-semibold text-sm hover:bg-red-700 transition"
        >
          {confirmText}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;